import React, { useEffect, useState } from "react";
import BlackoutDialog from "../../components/LeftMenu/BlackoutDialog";
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import NewReleasesOutlinedIcon from '@material-ui/icons//NewReleasesOutlined';

const useStyles = makeStyles(() => ({
    notificationMsg: {
        cursor: 'pointer',
        color: 'red',
        fontSize: '1rem',
        fontWeight: 700,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: "100%"
    },
    notificationIcon: {
        fontSize: '1.5rem',
        margin: '0 5px'
    }
}))

const NotificationMessage: React.FC = () => {
    const classes = useStyles();
    const [showBlackoutPopUp, setShowBlackoutPopUp] = useState<boolean>(false);
    const [blackOutPopUpData, setBlackoutPopUpData] = useState<any>([]);
    const [showHeading, setShowHeading] = useState<boolean>(false);
    const { blackoutNotificationDetails }: any = useSelector((state: any) => state.announcements);

    const getBackoutNotification = async () => {
        if (blackoutNotificationDetails?.data?.message?.status === "S" && blackoutNotificationDetails?.data?.data?.[0]) {
            setShowBlackoutPopUp(true);
            setBlackoutPopUpData(blackoutNotificationDetails.data.data[0]);
        }
    }
    useEffect(() => {
        if (blackoutNotificationDetails?.data?.message?.status === "S" && blackoutNotificationDetails?.data?.data?.[0]) {
            let publishDate = blackoutNotificationDetails?.data?.data?.[0].publishdate;
            const targetDate = new Date(publishDate);
            const now = new Date();
            if (now >= targetDate) {
                setShowHeading(true);
            }
        } else {
            setShowHeading(false);
        }
    }, [blackoutNotificationDetails]);

    return (
        <>
            {
                showHeading ?
                    <>
                        <div className={classes.notificationMsg} onClick={() => getBackoutNotification()}>
                            <a> <span className={classes.notificationIcon}><NewReleasesOutlinedIcon /></span>{blackoutNotificationDetails?.data?.data?.[0]?.description}
                            </a>
                        </div>
                        <BlackoutDialog
                            open={showBlackoutPopUp}
                            handleopenClose={(data: any) => { setShowBlackoutPopUp(data ? true : false) }}
                            blackOutPopUpData={blackOutPopUpData}
                        />
                    </>
                    : null
            }
        </>
    )
}

export default NotificationMessage;